import React from 'react'
import ReactDOM from 'react-dom'
import { FluentCustomizations } from '@uifabric/fluent-theme'
import { Customizer, mergeStyles } from 'office-ui-fabric-react'
import { initializeIcons } from 'new-icons'
import { client, ensureAuthentication } from './Api/api'
import { ApolloProvider } from 'react-apollo'
import { App } from './Layout/App'
import './index.css'
import { SessionContextProvider } from './Components/SessionContextProvider'
import { isInIframe } from './Utils/iframe'

ensureAuthentication()

initializeIcons(`${process.env.PUBLIC_URL}/icons/`)

mergeStyles({
  selectors: {
    ':global(body), :global(html), :global(#root)': {
      margin: 0,
      padding: 0,
      height: '100vh',
    },
  },
})

// 023741

FluentCustomizations.settings.theme.palette = {
  themePrimary: 'var(--color-primary)',
  themeLighterAlt: 'var(--color-theme-lighter-alt)',
  themeLighter: 'var(--color-theme-lighter)',
  themeLight: 'var(--color-theme-light)',
  themeTertiary: 'var(--color-primary-light)',
  themeSecondary: 'var(--color-primary-light)',
  themeDarkAlt: 'var(--color-theme-dark-alt)',
  themeDark: 'var(--color-theme-dark)',
  themeDarker: 'var(--color-theme-darker)',
  neutralLighterAlt: 'var(--color-background-light)',
  neutralLighter: 'var(--color-neutral-lighter)',
  neutralLight: 'var(--color-background-medium)',
  neutralQuaternaryAlt: 'var(--color-neutral-quaternary-alt)',
  neutralQuaternary: 'var(--color-neutral-quaternary)',
  neutralTertiaryAlt: 'var(--color-neutral-tertiary-alt)',
  neutralTertiary: 'var(--color-neutral-tertiary)',
  neutralSecondary: 'var(--color-neutral-secondary)',
  neutralPrimaryAlt: 'var(--color-neutral-primary-alt)',
  neutralPrimary: 'var(--color-neutral-primary)',
  neutralDark: 'var(--color-neutral-dark)',
  black: 'var(--color-black)',
  white: 'var(--color-white)',
}

type ExtendedWindow = Window & {
  Beacon: any
  attachEvent: any
}

const extendedWindow = window as unknown as ExtendedWindow

;(function (e: ExtendedWindow, t: Document, n: any) {
  function a() {
    var e = t.getElementsByTagName('script')[0],
      n = t.createElement('script')
    n.type = 'text/javascript'
    n.async = !0
    n.src = 'https://beacon-v2.helpscout.net'
    e.parentNode!.insertBefore(n, e)
  }
  if (
    ((e.Beacon = n =
      function (t: string, n: any, a: any) {
        e.Beacon.readyQueue.push({ method: t, options: n, data: a })
      }),
    (n.readyQueue = []),
    'complete' === t.readyState)
  )
    return a()
  e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1)
})(extendedWindow, document, extendedWindow.Beacon || function () {})

if (isInIframe()) {
  document.body.classList.add('r2b2')
} else {
  extendedWindow.Beacon('init', '728859b0-5133-4c61-b8a4-38d648e9004b')
  extendedWindow.Beacon('config', {
    color: '#023741',
    mode: 'neutral',
  })
}

ReactDOM.render(
  <Customizer {...FluentCustomizations}>
    <ApolloProvider client={client}>
      <SessionContextProvider>
        <App />
      </SessionContextProvider>
    </ApolloProvider>
  </Customizer>,
  document.getElementById('root')
)

console.log(`
Third-Party Software Licenses

This software includes third-party libraries and components.
Full license information for these can be found in our licenses file accessible at:
https://client.caroda.io/licenses.txt

We encourage all users of this library to review the licensing terms of the included third-party software.
`)
